import * as runtime from '@/api/runtime'
import {
  NotificationMailTemplate,
  NotificationMailTemplateFromJSON,
  NotificationMailUser,
  NotificationMailUserFromJSON,
  RegisterNotificationMailTemplateRequest,
  RegisterNotificationMailTemplateRequestToJSON,
  SearchNotificationMailUserRequest,
  SearchNotificationMailUserRequestToJSON,
  UpdateNotificationMailTemplateRequest,
  UpdateNotificationMailTemplateRequestToJSON,
  DeleteNotificationMailTemplateRequest,
  SendNotificationMailRequest,
  SendNotificationMailRequestToJSON
} from '@/api'
import { HTTPBody, HTTPQuery } from '@/api/runtime'

export class BatchNotificationMailApi extends runtime.BaseAPI {
  async searchNotificationMailUser(
    request: SearchNotificationMailUserRequest
  ): Promise<NotificationMailUser[]> {
    const queryParameters: HTTPQuery = Object.fromEntries(
      Object.entries(SearchNotificationMailUserRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery

    const response = await this.requestGet(
      '/batch/notification-mail/search-user',
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(NotificationMailUserFromJSON)
    ).value()
  }

  async getNotificationMailTemplate(): Promise<NotificationMailTemplate[]> {
    const response = await this.requestGet('/batch/notification-mail/template')

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(NotificationMailTemplateFromJSON)
    ).value()
  }

  async registerNotificationMailTemplate(
    request: RegisterNotificationMailTemplateRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = RegisterNotificationMailTemplateRequestToJSON(
      request
    ) as HTTPBody

    const response = await this.requestPost(
      '/batch/notification-mail/template',
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  async updateNotificationMailTemplate(
    request: UpdateNotificationMailTemplateRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = UpdateNotificationMailTemplateRequestToJSON(
      request
    ) as HTTPBody

    const response = await this.requestPut(
      `/batch/notification-mail/template/${request.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  async deleteNotificationMailTemplate(
    request: DeleteNotificationMailTemplateRequest
  ): Promise<runtime.VoidApiResponse> {
    const response = await this.requestDelete(
      `/batch/notification-mail/template/${request.id}`
    )

    return new runtime.VoidApiResponse(response)
  }

  async sendNotificationMail(
    request: SendNotificationMailRequest
  ): Promise<number> {
    const bodyParameters: HTTPBody = SendNotificationMailRequestToJSON(
      request
    ) as HTTPBody

    const response = await this.requestPost(
      '/batch/notification-mail/send',
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
